"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topOfLine = exports.explicit = exports.regexp = exports.or = void 0;
exports.or = (parsers) => {
    const { length } = parsers;
    return (text, position, rootParser) => {
        for (let i = 0; i < length; i++) {
            const match = parsers[i](text, position, rootParser);
            if (match) {
                return match;
            }
        }
        return null;
    };
};
exports.regexp = (pattern, callback) => (text, position, parseText) => {
    const match = text.substring(position).match(pattern);
    if (!match) {
        return null;
    }
    return callback(match, text, position, parseText);
};
exports.explicit = (parser) => (text, position, parseText) => {
    const prevChar = text.charAt(position - 1);
    if (prevChar && !prevChar.match(/[\s.,([{!?\-=]/)) {
        return null;
    }
    return parser(text, position, parseText);
};
exports.topOfLine = (parser) => (text, position, parseText) => {
    if (position > 0 && text.charAt(position - 1) !== '\n') {
        return null;
    }
    return parser(text, position, parseText);
};
//# sourceMappingURL=combinator.js.map